import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff } from "lucide-react";
import { api, errMsg, setToken } from "@/lib/api";

export const PasswordChange = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("New password and confirmation do not match");
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    setBusy(true);
    try {
      const r = await api.post("/admin/change-password", { current_password: current, new_password: next });
      setToken(r.data.token);
      toast.success("Password changed — use the new password next time");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const type = show ? "text" : "password";
  return (
    <form data-testid="admin-password-form" onSubmit={submit} className="kp-glass p-7 kp-card-clip flex flex-col gap-4">
      <div className="flex items-start justify-between">
        <div>
          <span className="kp-eyebrow">Security</span>
          <h2 className="font-display font-bold text-xl mt-1">Admin Password</h2>
        </div>
        <button type="button" data-testid="password-show-toggle" onClick={() => setShow(!show)} className="p-2 text-[#94A3B8] hover:text-white transition-colors" aria-label="Show passwords">
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
      <input data-testid="password-current-input" type={type} className="kp-input" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" />
      <div className="grid grid-cols-2 gap-3">
        <input data-testid="password-new-input" type={type} className="kp-input" placeholder="New password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={6} autoComplete="new-password" />
        <input data-testid="password-confirm-input" type={type} className="kp-input" placeholder="Confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" />
      </div>
      <button data-testid="password-change-submit" type="submit" disabled={busy} className="kp-btn kp-btn-ghost justify-center disabled:opacity-60">
        <KeyRound size={14} /> {busy ? "Saving..." : "Change Password"}
      </button>
    </form>
  );
};
